module.exports = __webpack_public_path__ + "img/sdg_es_(15).2b4b2d6a.png";